import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { MiscApi, RequestStrategyEnum, type GetContactsResponse } from '@shared/api';

interface UseContactsStore {
  loading: boolean;
  data?: GetContactsResponse | null;
  error: string | null;
  getContacts: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useContactsStore = create<UseContactsStore>((set, get) => ({
  loading: false,
  data: undefined,
  error: null,

  getContacts: ApiUtils.wrapperApi(async (signal) => {
    try {
      if (get().data) return;
      set({ loading: true, data: undefined, error: null });
      const result = await MiscApi.getContacts(signal);
      set({ loading: false, data: result || null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: undefined, error: null }),
}));
